// Theme color palette - Maroon, Black, and White
export const colors = {
  // Primary colors
  primary: {
    main: '#800020',      // Maroon
    light: '#A0153E',     // Light Maroon
    dark: '#5D0017',      // Dark Maroon
    contrast: '#FFFFFF'   // White text on maroon
  },

  // Secondary colors
  secondary: {
    main: '#1A1A1A',      // Almost Black
    light: '#2D2D2D',     // Lighter shade
    dark: '#000000',      // Pure Black
    contrast: '#FFFFFF'   // White text on black
  },

  // Background colors
  background: {
    main: '#FFFFFF',      // White
    default: '#FFFFFF',   // White
    paper: '#F8F8F8',     // Light Gray
    dark: '#1A1A1A',      // Dark background
    sidebar: '#2D2D2D'    // Sidebar background
  },

  // Text colors
  text: {
    primary: '#1A1A1A',   // Almost Black
    secondary: '#666666', // Gray
    tertiary: '#999999',  // Light Gray
    disabled: '#999999',  // Light Gray
    white: '#FFFFFF'      // White
  },

  // Status colors
  success: {
    main: '#28A745',
    light: '#48C765',
    dark: '#1E7E34'
  },
  error: {
    main: '#DC3545',
    light: '#E4606D',
    dark: '#BD2130'
  },
  warning: {
    main: '#FFC107',
    light: '#FFD54F',
    dark: '#FFA000'
  },
  info: {
    main: '#17A2B8',
    light: '#3FC3D8',
    dark: '#117A8B'
  },

  // Status colors (legacy support)
  status: {
    success: '#28A745',   // Green
    error: '#DC3545',     // Red
    warning: '#FFC107',   // Amber
    info: '#17A2B8'       // Cyan
  },

  // Neutral colors
  neutral: {
    50: '#F8F9FA',
    100: '#F1F3F5',
    200: '#E9ECEF',
    300: '#DEE2E6',
    400: '#CED4DA',
    500: '#ADB5BD',
    600: '#6C757D',
    700: '#495057',
    800: '#343A40',
    900: '#212529'
  },

  // Border colors
  border: {
    light: '#E0E0E0',
    main: '#CCCCCC',
    dark: '#999999'
  },

  // Chart colors (complementary to maroon theme)
  chart: {
    primary: '#800020',
    secondary: '#A0153E',
    tertiary: '#5D0017',
    accent1: '#C4A484',   // Tan
    accent2: '#8B7355',   // Brown
    accent3: '#D4AF37'    // Gold
  },

  // Spacing
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px'
  },

  // Border Radius
  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '12px',
    xl: '16px',
    round: '50%'
  },

  // Shadows
  shadows: {
    sm: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
    md: '0 3px 6px rgba(0,0,0,0.15), 0 2px 4px rgba(0,0,0,0.12)',
    lg: '0 10px 20px rgba(0,0,0,0.15), 0 3px 6px rgba(0,0,0,0.10)',
    xl: '0 15px 25px rgba(0,0,0,0.15), 0 5px 10px rgba(0,0,0,0.05)'
  },

  // Typography
  typography: {
    fontFamily: {
      primary: "'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif",
      heading: "'Poppins', 'Segoe UI', sans-serif",
      mono: "'Courier New', monospace"
    },
    fontSize: {
      xs: '12px',
      sm: '14px',
      md: '16px',
      lg: '18px',
      xl: '20px',
      xxl: '24px',
      h1: '32px',
      h2: '28px',
      h3: '24px',
      h4: '20px',
      h5: '18px',
      h6: '16px'
    },
    fontWeight: {
      light: 300,
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700
    }
  }
};

// Export individual objects for convenience (legacy support)
export const spacing = colors.spacing;
export const borderRadius = colors.borderRadius;
export const shadows = colors.shadows;
export const typography = colors.typography;
